import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import challengeService from "./challengeService";

export const getChallenges = createAsyncThunk(
  "challenge/get-challenges",
  async (params, thunkAPI) => {
    try {
      return await challengeService.getChallenges(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getChallenge = createAsyncThunk(
  "challenge/get-challenge",
  async (data, thunkAPI) => {
    try {
      return await challengeService.getChallenge(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createChallenge = createAsyncThunk(
  "challenge/create-challenge",
  async (data, thunkAPI) => {
    try {
      return await challengeService.createChallenge(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateChallenge = createAsyncThunk(
  "challenge/update-challenge",
  async (data, thunkAPI) => {
    try {
      return await challengeService.updateChallenge(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteChallenge = createAsyncThunk(
  "challenge/delete-challenge",
  async (data, thunkAPI) => {
    try {
      return await challengeService.deleteChallenge(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateChallengeStatus = createAsyncThunk(
  "customer/update-challenge-status",
  async (data, thunkAPI) => {
    try {
      return await challengeService.updateChallengeStatus(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getChallengeEntries = createAsyncThunk(
  "challenge/get-challenge-entries",
  async (params, thunkAPI) => {
    try {
      return await challengeService.getChallengeEntries(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getChallengeEntry = createAsyncThunk(
  "challenge/get-challenge-entry",
  async (data, thunkAPI) => {
    try {
      return await challengeService.getChallengeEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateChallengeEntry = createAsyncThunk(
  "challenge/update-challenge-entry",
  async (data, thunkAPI) => {
    try {
      return await challengeService.updateChallengeEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const approveChallengeEntry = createAsyncThunk(
  "challenge/approve-challenge-entry",
  async (data, thunkAPI) => {
    try {
      return await challengeService.approvedChallengeEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const rejectChallengeEntry = createAsyncThunk(
  "challenge/reject-challenge-entry",
  async (data, thunkAPI) => {
    try {
      return await challengeService.rejectChallengeEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addToFeedChallengeEntry = createAsyncThunk(
  "challenge/add-to-feed-challenge-entry",
  async (data, thunkAPI) => {
    try {
      return await challengeService.addToFeedChallengeEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const removeFromFeedChallengeEntry = createAsyncThunk(
  "challenge/remove-from-feed-challenge-entry",
  async (data, thunkAPI) => {
    try {
      return await challengeService.removeFromFeedChallengeEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  challenges: [],
  challengeEntries: [],
  total: 0,
  challengeEntryCount: 0,
  challenge: {},
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  updating: false,
  isUpdateSuccess: false,
  creating: false,
  isCreateSuccess: false,
  isUpdateStatusSuccess: false,
  challengeEntry: {},
};
export const challengeSlice = createSlice({
  name: "challenge",
  initialState,
  reducers: {
    initChallenge: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
      state.updating = false;
      state.isUpdateSuccess = false;
      state.creating = false;
      state.isCreateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChallenges.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getChallenges.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.challenges = action.payload.challenges;
        state.total = action.payload.challengeCount;
        state.isCreateSuccess = false;
        state.isUpdateSuccess = false;
      })
      .addCase(getChallenges.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createChallenge.pending, (state, action) => {
        state.creating = true;
        state.isCreateSuccess = false;
      })
      .addCase(createChallenge.rejected, (state, action) => {
        state.isError = true;
        state.creating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(createChallenge.fulfilled, (state, action) => {
        state.challenge = action.payload;
        state.creating = false;
        state.isCreateSuccess = true;
      })
      .addCase(updateChallenge.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updateChallenge.rejected, (state, action) => {
        state.isError = true;
        state.message = action.payload.response.data.message[0];
        state.updating = false;
      })
      .addCase(updateChallenge.fulfilled, (state, action) => {
        state.challenge = action.payload;
        state.updating = false;
        state.isUpdateSuccess = true;
      })
      .addCase(updateChallengeStatus.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
        const { id, data } = action.meta.arg;
        state.challenges = state.challenges.map((customer) =>
          customer.id === id ? { ...customer, ...data } : customer);
      })
      .addCase(updateChallengeStatus.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(updateChallengeStatus.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
      })

      .addCase(deleteChallenge.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
      })
      .addCase(deleteChallenge.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(deleteChallenge.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
        // Assuming action.payload contains the id of the deleted challenge
        const deletedId = action.meta.arg.id; // Or whatever your payload structure is    
        // Remove the challenge from the state
        state.challenges = state.challenges.filter(
          (customer) => customer.id !== deletedId
        );
      })

      .addCase(getChallenge.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getChallenge.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.challenge = action.payload;
      })
      .addCase(getChallenge.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getChallengeEntries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getChallengeEntries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.challengeEntries = action.payload.challengeEntries;
        state.challengeEntryCount = action.payload.challengeEntryCount;
        state.isCreateSuccess = false;
        state.isUpdateSuccess = false;
      })
      .addCase(getChallengeEntries.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getChallengeEntry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getChallengeEntry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.challengeEntry = action.payload;
      })
      .addCase(getChallengeEntry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateChallengeEntry.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updateChallengeEntry.rejected, (state, action) => {
        state.isError = true;
        state.message = action.payload.response.data.message[0];
        state.updating = false;
      })
      .addCase(updateChallengeEntry.fulfilled, (state, action) => {
        state.challengeEntry = action.payload;
        state.updating = false;
        state.isUpdateSuccess = true;
      })  
  },
});
export default challengeSlice.reducer;
export const { initChallenge } = challengeSlice.actions;